"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = parse;var _react = _interopRequireDefault(require("react"));
var _standalone = require("@babel/standalone");function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

var reactProxy = _react["default"];

function getComps(jsxCode) {
  var matches = [];
  jsxCode.replace(/\nconst +(\w[\w\d]*)/gi, function (m, p1) {
    matches.push(p1);
  });
  return matches;
}

function parse(jsxCode) {
  var comps = getComps('\n' + jsxCode);

  var fullJsxCode = "\nconst React = reactProxy\n".concat(

  jsxCode, "\nmodule.exports = {components: [").concat(
  comps, "]}\n");

  var jsCode = (0, _standalone.transform)(fullJsxCode, { presets: ['env', 'react'] }).code;var _eval =

  eval(jsCode),components = _eval.components;

  return components;
}